import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { listByCategory, formatHeat } from '@/utils/content';

export default function ContrastShow() {
  const list = listByCategory('contrast');
  if (!list.length) return null;
  const [big, ...rest] = list;

  return (
    <section className="bg-cream-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-secondary-600">
              人前人后两副面孔
            </span>
            <h2 className="mt-1 font-display text-2xl text-ink md:text-3xl">反差瞬间 · 快乐源泉</h2>
          </div>
          <Link to="/column/contrast" className="flex items-center gap-1 whitespace-nowrap text-sm font-bold text-secondary-700 hover:text-secondary-800">
            看更多反差 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <Link
            to={`/article/${big.id}`}
            className="group relative block overflow-hidden rounded-2xl border-4 border-white lg:col-span-2"
          >
            <img
              src={big.cover}
              alt={big.coverAlt}
              className="aspect-[16/9] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-block rounded-full bg-secondary-500 px-3 py-1 text-xs font-bold text-cream-50">
                编辑精选
              </span>
              <h3 className="mt-3 text-lg font-bold leading-snug text-white md:text-2xl">{big.title}</h3>
              <p className="mt-2 line-clamp-2 text-sm text-cream-100">{big.excerpt}</p>
              <span className="mt-3 inline-flex items-center gap-2 text-xs text-cream-100">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-300" />
                  {formatHeat(big.heat)} 热度
                </span>
                阅读全文
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.slice(0, 2).map((a) => (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                className="group flex flex-1 gap-3 overflow-hidden rounded-2xl border border-cream-200 bg-white p-3 transition-all hover:border-secondary-300"
              >
                <img src={a.cover} alt={a.coverAlt} className="h-full w-28 shrink-0 rounded-xl object-cover object-top" />
                <div className="flex flex-1 flex-col justify-center">
                  <h3 className="line-clamp-2 text-sm font-bold leading-snug text-ink group-hover:text-secondary-700">
                    {a.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs text-ink-600">{a.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}